import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { useAuth } from '../../contexts/AuthContext';
import LanguageSelector from './LanguageSelector';
import Logo from './Logo';
import '../LandingPage.css';

const LandingHeader = () => {
  const { t } = useLanguage();
  const { isAuthenticated } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  // Close menu on Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isMobileMenuOpen) {
        closeMobileMenu();
      }
    };
    
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isMobileMenuOpen]);

  return (
    <>
      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="landing-mobile-overlay" onClick={closeMobileMenu}></div>
      )}

      {/* Navigation Header */}
      <header className="landing-header">
        <div className="landing-container">
          <div className="landing-nav">
            <Logo />
            
            {/* Mobile Actions (Language Selector + Burger) */}
            <div className="landing-mobile-actions">
              <LanguageSelector />
              <button 
                className="landing-burger-menu" 
                onClick={toggleMobileMenu}
                aria-label="Toggle menu"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="3" y1="6" x2="21" y2="6"></line>
                  <line x1="3" y1="12" x2="21" y2="12"></line>
                  <line x1="3" y1="18" x2="21" y2="18"></line>
                </svg>
              </button>
            </div>

            {/* Desktop Nav Actions */}
            <div className="landing-nav-actions desktop-only">
              <LanguageSelector />
              <Link to="/pricing" className="landing-nav-link">
                {t('pricing.pricing')}
              </Link>
              {!isAuthenticated ? (
                <>
                  <Link to="/login" className="landing-nav-link">
                    {t('auth.login')}
                  </Link>
                  <Link to="/register" className="landing-button primary">
                    {t('landing.getStarted')}
                  </Link>
                </>
              ) : (
                <Link to="/dashboard" className="landing-button primary">
                  {t('navigation.dashboard')}
                </Link>
              )}
            </div>

            {/* Mobile Menu */}
            <div className={`landing-mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
              <div className="landing-mobile-menu-header">
                <h3>{t('common.menu')}</h3>
                <button className="landing-mobile-close" onClick={closeMobileMenu} aria-label="Close menu">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
              
              <div className="landing-mobile-menu-content">
                <div className="landing-mobile-menu-links">
                  <Link to="/" className="landing-mobile-link" onClick={closeMobileMenu}>
                    <span className="mobile-link-icon">🏠</span>
                    <span className="mobile-link-text">{t('navigation.home', 'Home')}</span>
                  </Link>
                  <Link to="/pricing" className="landing-mobile-link" onClick={closeMobileMenu}>
                    <span className="mobile-link-icon">💳</span>
                    <span className="mobile-link-text">{t('pricing.pricing')}</span>
                  </Link>
                  {!isAuthenticated ? (
                    <>
                      <Link to="/login" className="landing-mobile-link" onClick={closeMobileMenu}>
                        <span className="mobile-link-icon">👤</span>
                        <span className="mobile-link-text">{t('auth.login')}</span>
                      </Link>
                      <Link to="/register" className="landing-mobile-link primary" onClick={closeMobileMenu}>
                        <span className="mobile-link-icon">🚀</span>
                        <span className="mobile-link-text">{t('landing.getStarted')}</span>
                      </Link>
                    </>
                  ) : (
                    <Link to="/dashboard" className="landing-mobile-link primary" onClick={closeMobileMenu}>
                      <span className="mobile-link-icon">📊</span>
                      <span className="mobile-link-text">{t('navigation.dashboard')}</span>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default LandingHeader;

